import { FestivalItem } from '~/src/components/festival/FestivalItem'
import { useFestivalsContext } from '~/src/contexts'
import { nonNullable } from '~/src/utils'

export function FestivalList() {
  const { items, loading, error } = useFestivalsContext()
	
  if (loading || error) return null

  return (
    <div className="mb-20">
      {items.filter(nonNullable).map(item => (
        <FestivalItem
          data={item}
          key={item.id} />
      ))}
    </div>
  )
}